import { AutogenModelActivityHistory, AutogenRowActivityHistory } from "./autogen/AutogenModelActivityHistory";

export class ModelActivityHistory extends AutogenModelActivityHistory<RowActivityHistory> {
	constructor() {
		super(RowActivityHistory);
	}
}

export class RowActivityHistory extends AutogenRowActivityHistory {
}